module.exports = __webpack_public_path__ + "static/logo-light-7a643a30cb60baee6858319a9bd6faf2.png";